<script>
    import NavItem from "../components/NavItem.svelte";
</script>

<div class="py-16 flex-1 flex flex-col items-stretch justify-start gap-1">
    <div class="header-box mb-2">
        Work and experience
    </div>
    <div class="text-box mb-2">
        Hey! I'm currently a freelance developer, I also do art and work on personal projects in my free time.
        <br>
        I primarily use <b>Unity C# or Godot</b>, but I also have a fair amount of experience working with <b>C++ (including OpenGL), Python, Lua and HLSL</b>.<br>
        <br>
        <div class="image-group">
            <img src="img/paleo/game.png" class="image-item">
            <video autoplay muted loop class="image-item">
                <source src="img/paleo/gameplay.mp4" type="video/mp4">
            </video>
        </div>
        <br>
        Previously, I was employed for around 2 years as a Gameplay Programmer at <a href="https://italicpig.com/" target="_blank" rel="noopener noreferrer" class="link">Italic Pig</a>, working on <a href="https://store.steampowered.com/app/1202200/Paleo_Pines/" class="link" target="_blank" rel="noopener noreferrer">Paleo Pines</a>. My main responsibility is implementing gameplay systems, but I also often get involved in tasks outside programming. You can read more about my experience <a href="/paleo" class="link">here</a>.
        <br><br>
        <div class="image-group">
            <!-- <img src="img/icedrop/logo.png" class="image-item"> -->
            <video autoplay muted loop class="image-item">
                <source src="video/reel_games_hq.mp4" type="video/mp4">
            </video>
        </div>
        <br>
        <br>
        I also do quite a lot of technical art, making shaders and custom tools for my games and other projects. I'm currently helping with developing a C++ <a href="https://github.com/RainCatalyst/ZeusRenderer" class="link" target="_blank" rel="noopener noreferrer">Pathtracing Render Engine</a> as a part of the Computer Graphics department at my university. 
        <br>
        <br><br>
        <div class="image-group">
            <!-- <img src="img/icedrop/logo.png" class="image-item"> -->
            <img src="img/scene.png" class="image-item">
            <img src="img/cloud.png" class="image-item">
            <img src="img/lights.png" class="image-item">
        </div>
        <br>
        <br>
        Throughout the years participating in game jams I have published <a href="https://freezedice.itch.io/" target="_blank" rel="noopener noreferrer" class="link">over 15 projects</a> of various scope and made countless prototypes (most of which can be seen in the reel). One of my projects is <a href="https://store.steampowered.com/app/1819520/Constellations_Puzzles_in_the_Sky/" target="_blank" rel="noopener noreferrer" class="link">now released on Steam</a> and another one is coming there soon with a <a href="https://store.steampowered.com/app/2207440/LOK_Digital/" target="_blank" rel="noopener noreferrer" class="link">playable demo</a> available now.
        <!--Feel free to look at the <a href="/games" class="link">full list of my projects</a> (including some source code).-->
        <br>
        <br>
        Below you can find a list of tools that I've had experience using, but I'm always open to learning new ones!
        <br>
        <b>Languages:</b> C#, C++, HLSL, Python, GDScript<br>
        <b>Game Engines:</b> Unity, Godot, Unreal Engine<br>
        <b>Tools:</b> Blender, Houdini, Aseprite, Krita, Substance Designer
    </div>
    <NavItem text="back" href="/gamedev" local=true/>
</div>